/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import CashBoxPopup from './CashBoxPopup';

class CashboxDivInput extends React.Component {

    state: State = {
        keyboardVisible: false
    };

    static propTypes = {
        value: React.PropTypes.number,
        title: React.PropTypes.string.isRequired,
        className: React.PropTypes.string.isRequired,
        allOrganizationCashboxes: React.PropTypes.object,
        onSubmit: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.openKeyboard = this.openKeyboard.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.getCashboxName = this.getCashboxName.bind(this);
    }

    openKeyboard(open) {
        this.setState({keyboardVisible: open});
    }

    onSubmit(val) {
        const {onSubmit} = this.props;
        onSubmit(parseInt(val));
        this.openKeyboard(false);
    }

    getCashboxName(id) {
        const {allOrganizationCashboxes} = this.props;
        if (!allOrganizationCashboxes) {
            return '';
        }
        const index = allOrganizationCashboxes.findIndex(c => c.get('id') === id);
        if (index > -1) {
            return allOrganizationCashboxes.getIn([index, 'name']);
        }
        return '';
    }

    render() {
        const {value, title, className} = this.props;
        const {keyboardVisible} = this.state;
        const val = typeof value === 'undefined' ? '' : value;

        return (
            <div className={className}>
                <div className="form-row" onClick={() => this.openKeyboard(true)}>
                    <label className="form-label">{title}:</label>
                    <input className="form-input text-center" readOnly value={this.getCashboxName(val)}/>
                </div>
                {keyboardVisible &&
                <CashBoxPopup defaultValue={val}
                              onClose={() => this.openKeyboard(false)}
                              onSubmit={this.onSubmit}/>
                }
            </div>
        );
    }
}

export default connect(state => ({
    allOrganizationCashboxes: state.cashboxes.get('allOrganizationCashboxes')
}))(CashboxDivInput);



// WEBPACK FOOTER //
// ./src/browser/menu/report/transactions/CashboxDivInput.js